import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBlogPosts } from "@/lib/api";
import { pickL } from "@/lib/content";
import { useLang } from "@/context/LanguageContext";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

export default function Blog() {
  const { t, lang } = useLang();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  useReveal([posts.length]);

  useEffect(() => {
    setLoading(true);
    setError(false);
    getBlogPosts()
      .then((data) => setPosts(Array.isArray(data) ? data : []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [reloadKey]);

  return (
    <>
      <PageHero tag={t("blog.tag")} title={t("blog.title")} subtitle={t("blog.subtitle")} />
      <Breadcrumb trail={[{ label: t("nav.home"), to: "/" }, { label: t("nav.rituals") }]} />

      {loading ? (
        <div className="loader" data-testid="blog-loading"><div className="spinner" /></div>
      ) : error ? (
        <div className="boutique-state" data-testid="blog-error">
          <p>{t("blog.error")}</p>
          <button className="btn-primary" onClick={() => setReloadKey((k) => k + 1)} data-testid="blog-retry">{t("blog.retry")}</button>
        </div>
      ) : (
        <div className="blog-grid" data-testid="blog-grid">
          {posts.map((post) => (
            <Link to={`/blog/${post.slug}`} className="blog-card" key={post.slug} data-testid={`blog-card-${post.slug}`}>
              <img src={post.image} alt={pickL(post, "title", lang)} loading="lazy" />
              <div className="blog-card__body">
                <span className="blog-card__cat">{pickL(post, "category", lang)} · {post.date}</span>
                <h2 className="blog-card__title">{pickL(post, "title", lang)}</h2>
                <p className="blog-card__excerpt">{pickL(post, "excerpt", lang)}</p>
                <span className="blog-card__link">{t("common.readMore")}</span>
              </div>
            </Link>
          ))}
        </div>
      )}

      <NewsletterSection />
    </>
  );
}
